import UpgradeToTeamDialog from "@/dialogs/upgrade-to-team-dialog";
import { store } from "@store";
import { openDialog } from "@store/dialogs";

export const openTeamDialog = (source: string) => {
  store.dispatch(
    openDialog({
      id: "upgrade-to-team",
      content: UpgradeToTeamDialog,
      props: { source },
    }),
  );
};
